<ng-container [gaCategory]="eventCategory">

  <!-- Actions -->
  <button #nodeActionsTrigger="matMenuTrigger" app-button data-test="nodeActionsTrigger" buttonSize="xsmall"
    [buttonTheme]="theme" [matMenuTriggerFor]="nodeActions" (menuClosed)="onMenuClosed()">
    <app-icon icon="ellipsis-v"></app-icon>
  </button>

  <!-- Main manu -->
  <mat-menu #nodeActions="matMenu" [overlapTrigger]="true">
    <!-- Select -->
    <ng-container *appFlagApplication="application.All; page: '/edit', mode:'include'">
      <button mat-menu-item [matMenuTriggerFor]="selectActions">Select</button>
      <mat-divider></mat-divider>
    </ng-container>

    <!-- Show / Hide -->
    <button gaEvent gaAction="Clicked Show" mat-menu-item data-test="nodeActionsShow"
      (click)="toggleVisible(node, true)" *ngIf="!node.boolState.shown">Show</button>
    <button gaEvent gaAction="Clicked Hide" mat-menu-item data-test="nodeActionsHide"
      (click)="toggleVisible(node, false)" *ngIf="node.boolState.shown">Hide</button>

    <!-- Isolate -->
    <button gaEvent gaAction="Clicked Isolate" mat-menu-item data-test="nodeActionsIsolate"
      (click)="hideInverse(node)">Isolate</button>

    <!-- Fade -->
    <mat-divider></mat-divider>
    <button data-test="nodeActionsFadeTrigger" mat-menu-item [matMenuTriggerFor]="fadeActions">Fade</button>

    <!-- Pickable / Unpickable -->
    <ng-container *appFlagApplication="application.Loft">
      <mat-divider></mat-divider>
      <button mat-menu-item data-test="nodeActionsPickableTrigger" [matMenuTriggerFor]="pickableActions">Pickable /
        Unpickable</button>
    </ng-container>

    <!-- Fly To -->
    <mat-divider></mat-divider>
    <button gaEvent gaAction="Clicked Fly To" mat-menu-item data-test="nodeActionsFlyTo" (click)="flyToNode(node)">Fly
      To</button>

    <!-- Object Label -->
    <ng-container *appFlagApplication="application.Loft; page: '/edit', mode:'include'">
      <mat-divider></mat-divider>
      <button gaEvent gaAction="Clicked Edit Object Name" mat-menu-item data-test="nodeActionsEditName"
        (click)="editNodeLabel(node)">Edit Object Name</button>
    </ng-container>

    <!-- Copy -->
    <ng-container *appFlagApplication="application.Loft; page: '/edit', mode:'include'">
      <mat-divider></mat-divider>
      <button mat-menu-item data-test="nodeActionsCopyTrigger" [matMenuTriggerFor]="copyActions">Copy</button>
    </ng-container>

    <!-- Eyedropper -->
    <ng-container *appFlagApplication="application.All; page: '/edit', mode:'include'">
      <mat-divider></mat-divider>
      <button gaEvent gaAction="Clicked Sample Paint" mat-menu-item data-test="nodeActionsSamplePaint"
        (click)="samplePaint(node)">Sample Paint</button>
    </ng-container>
  </mat-menu>

  <!-- Select submenu -->
  <mat-menu #selectActions="matMenu">
    <button gaEvent gaAction="Clicked Select This" mat-menu-item data-test="nodeActionsSelectThis"
      (click)="checkNode(node, true)">Select This</button>
    <button gaEvent gaAction="Clicked Select Everything Else" mat-menu-item data-test="nodeActionsSelectEverythingElse"
      (click)="checkInverse(node)">Select Everything Else</button>
  </mat-menu>

  <!-- Fade submenu -->
  <mat-menu #fadeActions="matMenu">
    <button gaEvent gaAction="Clicked Fade This" mat-menu-item data-test="nodeActionsFadeThis"
      (click)="fadeNode(node)">Fade This</button>
    <button gaEvent gaAction="Clicked Fade Everything Else" mat-menu-item data-test="nodeActionsFadeEverythingElse"
      (click)="fadeInverseNodes(node)">Fade Everything Else</button>
  </mat-menu>

  <!-- Show / Hide submenu -->
  <mat-menu #showHideActions="matMenu">
    <button gaEvent gaAction="Clicked Show This" mat-menu-item data-test="nodeActionsShowThis"
      (click)="toggleVisible(node, true)" *ngIf="!node.boolState.shown">Show This</button>
    <button gaEvent gaAction="Clicked Hide This" mat-menu-item data-test="nodeActionsShowEverythingElse"
      (click)="toggleVisible(node, false)" *ngIf="node.boolState.shown">Hide This</button>
    <mat-divider></mat-divider>
    <button gaEvent gaAction="Clicked Hide Everything Else" mat-menu-item (click)="hideInverse(node)">Hide Everything
      Else</button>
  </mat-menu>

  <!-- Pickable submenu -->
  <mat-menu #pickableActions="matMenu">
    <button gaEvent gaAction="Clicked Make Unpickable" *ngIf="node.boolState.pickable" mat-menu-item
      data-test="nodeActionsPickable" (click)="togglePickable(node, false)">Make Unpickable</button>
    <button gaEvent gaAction="Clicked Make Pickable" *ngIf="!node.boolState.pickable" mat-menu-item
      data-test="nodeActionsUnpickable" (click)="togglePickable(node, true)">Make Pickable</button>
    <mat-divider></mat-divider>
    <button gaEvent gaAction="Clicked Make Everything Else Unpickable" mat-menu-item
      data-test="nodeActionsEverythingElseUnpickable" (click)="makeEverythingElseUnpickale(node)">Make Everything Else
      Unpickable</button>
  </mat-menu>

  <!-- Copy submenu -->
  <mat-menu #copyActions="matMenu">
    <button gaEvent gaAction="Clicked Copy Short ID" mat-menu-item data-test="nodeActionsCopyShortID"
      (click)="copy(shortId)">Copy Short ID</button>
    <button gaEvent gaAction="Clicked Copy Full ID" mat-menu-item data-test="nodeActionsCopyFullID"
      (click)="copy(node.id)">Copy Full ID</button>
    <mat-divider></mat-divider>
    <button gaEvent gaAction="Clicked Copy Display Name" mat-menu-item data-test="nodeActionsCopyDisplayName"
      (click)="copy(node.label)">Copy Display Name</button>
  </mat-menu>

</ng-container>
